import exportimages from "../../../assets/images/exportImages";
import { CLUSTER_OBJECTS, FILTER_KEYS } from "../../../Redux/newClusterSlice";
import { PRIVILEGES } from "../../../utils/privileges";

export const DASHBOARD_CARDS = {
  FINANCIAL_BENCHMARK: "financialBenchmark",
  MISSED_EARNINGS: "missed_earnings",
  CONSUMER_BEHAVIOR: "consumer_behavior",
  OPPORTUNITIES: "opportunities",
  DEPOSITIES: "secondary_consumer",
  BEAT_THE_COMPETITION: "beat_the_competition",
  AUTOMATED_MARKETING: "automated_marketing",
  BANKING_SERVICES: "banking_services",
  GHOST_CONSUMERS: "ghost_consumers",
  TOP_PERSONA: "top_persona",
  DEMOGRAPHICS: "demographics",
  TOP_MERCHANTS: "top_merchants",
  TOP_VENDERS: "top_venders",
  TREND_MISSED_EARNINGS: "missedrevenue_trend",
  TREND_BOND_SCORE: "bondscore_trend",
  TREND_OPPORTUNITIES: "opportunities_trend",
  TREND_DEPOSITS: "secondaryconsumer_trend",
  TREND_GHOST_CONSUMERS: "ghostconsumer_trend",
};

export const OPPORTUNITIES = [
  {
    key: "credit_card",
    // name: "Credit Card",
    icon: exportimages.icon_credit_card,
    color: "#27CAE3",
  },
  {
    key: "consumer_loan",
    // name: "Consumer Loan",
    icon: exportimages.icon_consumer_loan,
    color: "#5CAEFF",
  },
  {
    key: "mortgage",
    // name: "Mortgage",
    icon: exportimages.icon_mortgage,
    color: "#FE6682",
  },
  {
    key: "auto_loan",
    // name: "Auto Loan",
    icon: exportimages.icon_auto_loan,
    color: "#6C7DE5",
  },
  {
    key: "student_loan",
    // name: "Student Loan",
    icon: exportimages.icon_student_loan,
    color: "#FF6DE8",
  },
  {
    key: "personal_loan",
    // name: "Personal Loan",
    icon: exportimages.icon_personal_loan,
    color: "#FFB30E",
  },
  {
    key: "business_loan",
    // name: "Business Loan",
    icon: exportimages.icon_business_loan,
    color: "#A099F3",
  },
  {
    key: "commercial_loan",
    // name: "Commercial Loan",
    icon: exportimages.icon_commercial_loan,
    color: "#3EE0D7",
  },
  {
    key: "deposit",
    // name: "Deposit",
    icon: exportimages.icon_deposit,
    color: "#A099F3",
  },
  {
    key: "checking",
    // name: "Checking Accounts",
    icon: exportimages.icon_checking,
    color: "#8577E6",
  },
  {
    key: "line_of_credit",
    // name: "Line of Credit",
    icon: exportimages.icon_line_of_credits,
    color: "#39D191",
  },
  {
    key: "term_loan",
    // name: "Term Loan",
    icon: exportimages.icon_term_loans,
    color: "#4AC8F5",
  },
  {
    key: "trade_finance",
    // name: "Trade Finance",
    icon: exportimages.icon_trade_finance,
    color: "#D18FF4",
  },
  {
    key: "p_card",
    // name: "P Card",
    icon: exportimages.icon_p_card,
    color: "#9B7BEB",
  },
  {
    key: "real_estate_loan",
    // name: "Real Estate Loan",
    icon: exportimages.icon_commercial_real_estate_loans,
    color: "#F07290",
  },
  {
    key: "corporate_card",
    // name: "Corporate Card",
    icon: exportimages.icon_corporate_credit_cards,
    color: "#EE8458",
  },
];

export const CONSUMERS_TYPES = [
  {
    key: "account_transfer",
    // name: "Account Transfer",
    icon: exportimages.icon_account_transfer,
    coloured_icon: exportimages.icon_account_transfer_coloured,
    color: "#1570EF",
  },
  {
    key: "checking",
    // name: "Checking Accounts (Demand Deposit Accounts, DDAs) ",
    icon: exportimages.icon_checking,
    coloured_icon: exportimages.icon_checking_coloured,
    color: "#8577E6",
  },
  {
    key: "savings",
    // name: "Savings Accounts",
    icon: exportimages.icon_savings,
    coloured_icon: exportimages.icon_savings_coloured,
    color: "#EA80AE",
  },
  {
    key: "certificates_of_deposit",
    // name: "Certificates of Deposit (CDs)",
    icon: exportimages.icon_certificates_of_deposit,
    coloured_icon: exportimages.icon_certificates_of_deposit_coloured,
    color: "#111f1dff",
  },
  {
    key: "ira",
    // name: "IRA Savings",
    icon: exportimages.icon_ira,
    coloured_icon: exportimages.icon_ira_coloured,
    color: "#FFD77A",
  },
  {
    key: "health_savings_account",
    // name: "Health Savings Account (HSA)",
    icon: exportimages.icon_health_savings_account,
    coloured_icon: exportimages.icon_health_savings_account_coloured,
    color: "#67A1E7",
  },
  {
    key: "529_education_accounts",
    // name: "529 Education Accounts",
    icon: exportimages.icon_529_education_accounts,
    coloured_icon: exportimages.icon_529_education_accounts_coloured,
    color: "#B48DF2",
  },
  {
    key: "investment",
    // name: "Investments",
    icon: exportimages.icon_investment,
    coloured_icon: exportimages.icon_investment_coloured,
    color: "#F79268",
  },
  {
    key: "commercial_investment",
    // name: "Investments",
    icon: exportimages.icon_commercial_investment,
    coloured_icon: exportimages.icon_commercial_investment_coloured,
    color: "#F79268",
  },
  {
    key: "general_transfer",
    // name: "General Transfer",
    icon: exportimages.icon_general_transfer,
    coloured_icon: exportimages.icon_general_transfer_coloured,
    color: "#45BE8B",
  },
  {
    key: "person_to_person",
    // name: "Person to Person",
    icon: exportimages.icon_person_to_person,
    coloured_icon: exportimages.icon_person_to_person_coloured,
    color: "#be56d6",
  },
  {
    key: "checking_account",
    // name: "Checking account",
    icon: exportimages.icon_checking,
    coloured_icon: exportimages.icon_checking_coloured,
    color: "#8577E6",
  },
  {
    key: "short_term_investment_solutions",
    // name: "Short-term Investment Solutions ",
    icon: exportimages.icon_short_term_investment_solutions,
    coloured_icon: exportimages.icon_short_term_investment_solutions_coloured,
    color: "#F07290",
  },
  {
    key: "zero_balance_account",
    // name: "Zero Balance Account",
    icon: exportimages.icon_zero_balance_account,
    coloured_icon: exportimages.icon_zero_balance_account_coloured,
    color: "#52C796",
  },
  {
    key: "operating_checking_account",
    // name: "Operating Checking Account",
    icon: exportimages.icon_operating_checking_account,
    coloured_icon: exportimages.icon_operating_checking_account_coloured,
    color: "#0FD8C1",
  },
  {
    key: "business_savings_account",
    // name: "Business Savings Account",
    icon: exportimages.icon_business_savings_account,
    coloured_icon: exportimages.icon_business_savings_account_coloured,
    color: "#F5723D",
  },
  {
    key: "remote_deposit_capture",
    // name: "Remote Deposit Capture",
    icon: exportimages.icon_remote_deposit_capture,
    coloured_icon: exportimages.icon_remote_deposit_capture_coloured,
    color: "#D495F5",
  },
  {
    key: "sweep_account",
    // name: "Sweeps",
    icon: exportimages.icon_sweep_account,
    coloured_icon: exportimages.icon_sweep_account_coloured,
    color: "#F37AAF",
  },
  {
    key: "money_market_account",
    // name: "Money Market Account",
    icon: exportimages.icon_money_market_account,
    coloured_icon: exportimages.icon_money_market_account_coloured,
    color: "#8576F0",
  },
  {
    key: "business_checking_account",
    // name: "Business Checking Account",
    icon: exportimages.icon_business_checking_account,
    coloured_icon: exportimages.icon_business_checking_account_coloured,
    color: "#FDAC34",
  },
  {
    key: "external_bank_transfers",
    // name: "External Bank Transfers",
    icon: exportimages.icon_external_bank_transfers,
    coloured_icon: exportimages.icon_external_bank_transfers_coloured,
    color: "#5D9AC6",
  },
];

export const GRAPH_TYPE = {
  BUBBLE_CHART: "bubble_chart",
  BUBBLE_PIE_CHART: "bubble_pie_chart",
};

export const CARD_TYPE = [
  {
    forRetail: true,
    forCommercial: true,
    id: DASHBOARD_CARDS.FINANCIAL_BENCHMARK,
    privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
    component: "OverviewCard",
    colSpan: 1,
    rowSpan: 2,
    retail_title: "Analyst",
    retail_description:
      "Overall score of your institution based on financial performance as compared to your cohort.",
    commercial_title: "Analyst",
    commercial_description:
      "Overall score of your institution based on financial performance as compared to your cohort.",
    backgroundColor: "#fff",
    apiQuery: [
      {
        summaryData: "getFHSDataByIdrssd",
      },
    ],
    onClickOfCard: "financialBenchmarkCardClick",
  },
  {
    forRetail: true,
    forCommercial: true,
    id: DASHBOARD_CARDS.MISSED_EARNINGS,
    privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
    component: "InsightCard",
    colSpan: 1,
    rowSpan: 1,
    retail_title: "Missed Earnings",
    retail_description:
      "Estimated revenue your institution is missing based on unattended needs of your consumers.",
    commercial_title: "Missed Earnings",
    commercial_description:
      "Estimated revenue your institution is missing based on unattended needs of your consumers.",
    icon: exportimages.dashboard_missed_revenue,
    backgroundColor: "#DFFBFF",
    rtkQuery: [
      {
        summaryData: "missedRevenueAnalysisSlice",
        function: "getMissedRevenueSummary",
      },
      {
        expandedData: "missedRevenueAnalysisSlice",
        function: "getMissedRevenueExpended",
      },
    ],
    onClickOfPopUpButton: "MissedEarningsPopup",
    lockedCardPopup: "missed_revenue",
  },
  {
    forRetail: true,
    forCommercial: true,
    id: DASHBOARD_CARDS.CONSUMER_BEHAVIOR,
    privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
    component: "InsightCard",
    colSpan: 1,
    rowSpan: 1,
    retail_title: "Consumer Behavior",
    retail_description:
      "Discover your consumer behavior patterns, personas and affinity to your institution.",
    commercial_title: "Commercial Account Behavior",
    commercial_description:
      "Discover your consumer behavior patterns, personas and affinity to your institution.",
    icon: exportimages.dashboard_bond_score,
    backgroundColor: "#DFFBFF",
    rtkQuery: [
      {
        fileAnalyticsExpanded: "fileAnalyticsAnalysisSlice",
        function: "getFileAnalyticsExpanded",
      },
      {
        summaryData: "secondaryConsumerAnalysisSlice",
        function: "getSecondaryConsumerSummary",
      },
      {
        expandedData: "secondaryConsumerAnalysisSlice",
        function: "getSecondaryConsumerExpended",
      },
    ],
    onClickOfPopUpButton: "ConsumerBehaviorPopUp",
    lockedCardPopup: "consumer_behavior",
  },
  {
    forRetail: true,
    forCommercial: true,
    id: DASHBOARD_CARDS.OPPORTUNITIES,
    privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
    component: "DashboardAccordionCard",
    colSpan: 1,
    rowSpan: 2,
    retail_title: "Product Opportunities",
    retail_description:
      "Get them before they Google. Identify clients searching for new loans, and convert clients with loans at competing institutions.",
    commercial_title: "Product Opportunities",
    commercial_description:
      "Get them before they Google. Identify clients searching for new loans, and convert clients with loans at competing institutions.",
    icon: exportimages?.uplift_loans,
    backgroundColor: "#fff",
    graph: GRAPH_TYPE.BUBBLE_CHART,
    rtkQuery: [
      {
        summaryData: "opportunitiesAnalysisSlice",
        function: "getOpportunitiesSummary",
      },
      {
        expandedData: "opportunitiesAnalysisSlice",
        function: "getOpportunitiesExpended",
      },
    ],
    item_array: [...OPPORTUNITIES],
    onClickOfCard: "clusterCardClick",
    clusterObject: CLUSTER_OBJECTS.opportunities,
    lockedCardPopup: "uplift_loans",
  },
  {
    forRetail: true,
    forCommercial: true,
    id: DASHBOARD_CARDS.DEPOSITIES,
    privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
    component: "DashboardAccordionCard",
    colSpan: 1,
    rowSpan: 2,
    retail_title: "Deposit Opportunities",
    retail_description:
      "Create offers to attract and retain DDA, savings, and wealth management accounts.",
    commercial_title: "Deposit Opportunities",
    commercial_description:
      "Create offers to encourage businesses to consolidate their deposit relationships with your institution.",
    icon: exportimages?.boost_deposits,
    backgroundColor: "#fff",
    graph: GRAPH_TYPE.BUBBLE_PIE_CHART,
    rtkQuery: [
      {
        summaryData: "secondaryConsumerAnalysisSlice",
        function: "getSecondaryConsumerSummary",
      },
      {
        expandedData: "secondaryConsumerAnalysisSlice",
        function: "getSecondaryConsumerExpended",
      },
    ],
    item_array: [...CONSUMERS_TYPES],
    onClickOfCard: "clusterCardClick",
    clusterObject: CLUSTER_OBJECTS.secondary_consumer,
    lockedCardPopup: "boost_deposits",
  },
  {
    forRetail: true,
    forCommercial: true,
    onlyForPopUp: true,
    id: DASHBOARD_CARDS.TOP_PERSONA,
    privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
    component: "DashboardCard",
    colSpan: 1,
    rowSpan: 2,
    retail_title: "Top Personas",
    retail_description: "Know the persona types of your consumers.",
    commercial_title: "Top Personas",
    commercial_description: "Know the persona types of your business.",
    backgroundColor: "#fff",
    rtkQuery: [
      {
        expandedData: "topPersonaAnalysisSlice",
        function: "getTopPersonaExpended",
      },
    ],
  },
  {
    forRetail: true,
    forCommercial: false,
    onlyForPopUp: true,
    id: DASHBOARD_CARDS.DEMOGRAPHICS,
    privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
    component: "DashboardCard",
    colSpan: 1,
    rowSpan: 2,
    retail_title: "Demographics",
    retail_description:
      "Demographics describe consumer age ranges and gender diversity to help tailor products or services to specific groups.",
    commercial_title: "Demographics",
    commercial_description:
      "Demographics describe consumer age ranges and gender diversity to help tailor products or services to specific groups.",
    backgroundColor: "#fff",
    rtkQuery: [
      {
        summaryData: "consumerDemographicsAnalysisSlice",
        function: "getConsumerDemographicsSummary",
      },
    ],
  },
  {
    forRetail: true,
    forCommercial: false,
    onlyForPopUp: true,
    id: DASHBOARD_CARDS.TOP_MERCHANTS,
    privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
    component: "DashboardCard",
    colSpan: 1,
    rowSpan: 2,
    retail_keyword: "Merchants",
    retail_title: "Top Merchants",
    retail_description:
      "Discover the non-financial merchants that your consumers are using the most.",
    commercial_keyword: "Merchants",
    commercial_title: "Top Merchants",
    commercial_description:
      "Discover the non-financial merchants that your consumers are using the most.",
    // icon: exportimages?.beat_the_competition,
    backgroundColor: "#fff",
    rtkQuery: [
      {
        summaryData: "topMerchantsAnalysisSlice",
        function: "getTopMerchantsSummary",
      },
      {
        expandedData: "topMerchantsAnalysisSlice",
        function: "getTopMerchantsExpended",
      },
    ],
    navigationLink: "topGainersLinkClick",
    onClickOfCard: "clusterCardClick",
    clusterObject: CLUSTER_OBJECTS.top_merchant,
    // lockedCardPopup: "beat_the_competition",
  },
  {
    forRetail: false,
    forCommercial: true,
    onlyForPopUp: true,
    id: DASHBOARD_CARDS.TOP_VENDERS,
    privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
    component: "DashboardCard",
    colSpan: 1,
    rowSpan: 2,
    retail_keyword: "Vendors",
    retail_title: "Top Vendors",
    retail_description:
      "Discover the non-financial vendors that your consumers are using the most.",
    commercial_keyword: "Vendors",
    commercial_title: "Top Vendors",
    commercial_description:
      "Discover the non-financial vendors that your consumers are using the most.",
    // icon: exportimages?.beat_the_competition,
    backgroundColor: "#fff",
    rtkQuery: [
      {
        summaryData: "topMerchantsAnalysisSlice",
        function: "getTopMerchantsSummary",
      },
      {
        expandedData: "topMerchantsAnalysisSlice",
        function: "getTopMerchantsExpended",
      },
    ],
    navigationLink: "topGainersLinkClick",
    onClickOfCard: "clusterCardClick",
    clusterObject: CLUSTER_OBJECTS.top_vendor,
    // lockedCardPopup: "beat_the_competition",
  },
  {
    forRetail: true,
    forCommercial: false,
    onlyForPopUp: true,
    id: DASHBOARD_CARDS.GHOST_CONSUMERS,
    privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
    component: "DashboardAccordionCard",
    colSpan: 1,
    rowSpan: 2,
    retail_title: "Ghost Consumers",
    retail_description:
      "Consumers preferring another financial institution's products over yours.",
    commercial_title: "Ghost Consumers",
    commercial_description:
      "Consumers preferring another financial institution's products over yours.",
    // icon: exportimages?.boost_deposits,
    backgroundColor: "#fff",
    graph: GRAPH_TYPE.BUBBLE_CHART,
    rtkQuery: [
      {
        summaryData: "ghostConsumerAnalysisSlice",
        function: "getGhostConsumerSummary",
      },
      {
        expandedData: "ghostConsumerAnalysisSlice",
        function: "getGhostConsumerExpended",
      },
    ],
    item_array: [...OPPORTUNITIES],
    showProgressBar: true,
    onClickOfCard: "clusterCardClick",
    clusterObject: CLUSTER_OBJECTS.ghost_consumer,
  },
  {
    forRetail: true,
    forCommercial: true,
    id: DASHBOARD_CARDS.BEAT_THE_COMPETITION,
    privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
    component: "DashboardCard",
    colSpan: 1,
    rowSpan: 2,
    retail_title: "Beat The Competition",
    retail_description: "Get deep insights into your competitors in seconds.",
    commercial_title: "Beat The Competition",
    commercial_description:
      "Get deep insights into your competitors in seconds.",
    icon: exportimages?.beat_the_competition,
    backgroundColor: "#fff",
    rtkQuery: [
      {
        summaryData: "topCompetitorsAnalysisSlice",
        function: "getTopCompetitorsSummary",
      },
      {
        expandedData: "topCompetitorsAnalysisSlice",
        function: "getTopCompetitorsExpended",
      },
    ],
    onClickOfPopUpButton: "BeatTheCompetitionPopUp",
    lockedCardPopup: "beat_the_competition",
  },
  {
    forRetail: true,
    forCommercial: false,
    id: DASHBOARD_CARDS.AUTOMATED_MARKETING,
    privilages: [
      ...PRIVILEGES.DASHBOARD_PAGE_ACCESS,
      ...PRIVILEGES.SHOW_EMAIL_CAMPAIGN_MANAGEMENT,
      // ...PRIVILEGES.SHOW_SMS_CAMPAIGN_MANAGEMENT,
      ...PRIVILEGES.SHOW_EMAIL_TEMPLATE_MANAGEMENT,
      ...PRIVILEGES.SHOW_CONSUMER_LIST_MANAGEMENT,
    ],
    component: "DashboardCard",
    colSpan: 1,
    rowSpan: 2,
    retail_title: "Automated Marketing",
    retail_description:
      "Launch instant data driven campaigns with pre-built templates.",
    commercial_title: "Automated Marketing",
    commercial_description:
      "Launch instant data driven campaigns with pre-built templates.",
    icon: exportimages?.automated_marketing,
    backgroundColor: "#fff",
    apiQuery: [
      {
        summaryData: "fetchEmailCampaignsSummary",
      },
    ],
    lockedCardPopup: "automated_marketing",
    navigationLink: "navigateToCampaignManagement",
  },
  {
    forRetail: false,
    forCommercial: true,
    id: DASHBOARD_CARDS.BANKING_SERVICES,
    privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
    component: "DashboardCard",
    colSpan: 1,
    rowSpan: 2,
    retail_title: "Banking Services",
    retail_description: "Grow your share of wallet by identifying businesses that can benefit from additional banking services.",
    commercial_title: "Banking Services",
    commercial_description:
      "Grow your share of wallet by identifying businesses that can benefit from additional banking services.",
    icon: exportimages?.banking_services,
    backgroundColor: "#fff",
    rtkQuery: [
      {
        summaryData: "bankingServicesAnalysisSlice",
        function: "getBankingServicesSummary",
      },
    ],
    onClickOfCard: "clusterCardClick",
    clusterObject: CLUSTER_OBJECTS.banking_services,
  },
];

export const TREND_TYPE = [
  {
    forRetail: true,
    forCommercial: true,
    id: DASHBOARD_CARDS.TREND_MISSED_EARNINGS,
    retail_title: "Missed Earnings",
    commercial_title: "Missed Earnings",
    rtkQuery: [
      {
        rtk: "trendRTK",
        function: "getMissingRevenueTrend",
      },
    ],
  },
  {
    forRetail: true,
    forCommercial: true,
    id: DASHBOARD_CARDS.TREND_BOND_SCORE,
    retail_title: "BOND Score",
    commercial_title: "BOND Score",
    rtkQuery: [
      {
        rtk: "trendRTK",
        function: "getBondScoreTrend",
      },
    ],
  },
  {
    forRetail: true,
    forCommercial: true,
    id: DASHBOARD_CARDS.TREND_OPPORTUNITIES,
    retail_title: "Product Opportunities",
    commercial_title: "Product Opportunities",
    rtkQuery: [
      {
        rtk: "trendRTK",
        function: "getOpportunitiesTrend",
      },
    ],
  },
  {
    forRetail: true,
    forCommercial: false,
    id: DASHBOARD_CARDS.TREND_GHOST_CONSUMERS,
    retail_title: "Ghost Consumers",
    commercial_title: "Ghost Consumers",
    rtkQuery: [
      {
        rtk: "trendRTK",
        function: "getGhostConsumersTrend",
      },
    ],
  },
  {
    forRetail: true,
    forCommercial: true,
    id: DASHBOARD_CARDS.TREND_DEPOSITS,
    retail_title: "Deposit Opportunities",
    commercial_title: "Deposit Opportunities",
    rtkQuery: [
      {
        rtk: "trendRTK",
        function: "getDepositsTrend",
      },
    ],
  },
];

export const DASHBOARD_TYPES = {
  RETAIL: {
    KEY: 1,
    NAME: "Retail",
    CONFIG: {
      pageHeader: {
        pageTitle: "Retail Banking",
        description:
          "Caters to larger businesses and corporations, providing services such as business loans, treasury management, and commercial real estate financing.",
        buttons: [
          {
            id: "trend_button",
            label: "Trend",
            buttonType: "TrendButton",
            privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
            icon: exportimages.trend,
            hoverIcon: exportimages.trendHover,
            disabledIcon: exportimages.trend_upgrade,
          },
          {
            id: "export_button",
            label: "Export",
            buttonType: "ExportButton",
            privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
            icon: exportimages.uploadNew,
            hoverIcon: exportimages.white_download_icon,
            disabledIcon: exportimages.export_upgrade,
          },
          {
            id: "data_analytics_button",
            label: "Data Analytics",
            buttonType: "DataAnalyticsButton",
            privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
          },
        ],
      },
      pageBody: [...CARD_TYPE.filter((card) => card.forRetail)],
      trendBody: [...TREND_TYPE.filter((trend) => trend.forRetail)],
    },
  },
  COMMERCIAL: {
    KEY: 2,
    NAME: "Commercial",
    CONFIG: {
      pageHeader: {
        pageTitle: "Commercial Banking",
        description:
          "Focuses on individual consumers and small businesses, offering services like savings accounts, loans, and credit cards.",
        buttons: [
          {
            id: "trend_button",
            label: "Trend",
            buttonType: "TrendButton",
            privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
            icon: exportimages.trend,
            hoverIcon: exportimages.trendHover,
            disabledIcon: exportimages.trend_upgrade,
            action: () => {
              // Implement download functionality here
              console.log("Download Report clicked");
            },
          },
          {
            id: "export_button",
            label: "Export",
            buttonType: "ExportButton",
            privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
            icon: exportimages.uploadNew,
            hoverIcon: exportimages.white_download_icon,
            disabledIcon: exportimages.export_upgrade,
            action: () => {
              // Implement download functionality here
              console.log("Download Report clicked");
            },
          },
          {
            id: "data_analytics_button",
            label: "Data Analytics",
            buttonType: "DataAnalyticsButton",
            privilages: PRIVILEGES.DASHBOARD_PAGE_ACCESS,
            action: () => {
              // Implement download functionality here
              console.log("Download Report clicked");
            },
          },
        ],
      },
      pageBody: [...CARD_TYPE.filter((card) => card.forCommercial)],
      trendBody: [...TREND_TYPE.filter((trend) => trend.forCommercial)],
    },
  },
};
